<div class="step_container" [formGroup]="form">
    <div class="steps_block">
        <div class="step no_step">
          <div class="step_title inline_title">
            <span>
              {{"inventory.inventory"|translate}}
            </span>
            <button (click)="closed()">
                <mat-icon style="color: black;">close</mat-icon>
              </button>
          </div>
          <div class="content">
            <div class="inline_block">
              <div class="field ">
                <label for="">{{"inventory.sku_code_type"|translate}}</label>
                <select name="" id="" disabled>
                  <option selected value="">{{"inventory.statics_input"|translate}}</option>
                </select>
              </div>
              <div class="field ">
                <label for="">{{"inventory.sKU_code"|translate}}<span class="red">*</span></label>
                <input value="" type="text" formControlName="sku" [placeholder]="'inventory.sku'|translate">
                <span class="error_ms" *ngIf="form.get('sku')?.touched && form.get('sku')?.errors">{{"common.required_field"|translate}}</span>
              </div>
              <div class="field ">
                <label for="">{{"inventory.barcode"|translate}}</label>
                <input type="number" [placeholder]="'inventory.barcode'|translate" formControlName="barcodeControl" class="input" (input)="sanitize($event)">
              </div>
            </div>
            <div class="inline_block">
              <div class="field ">
                <label for="">{{"inventory.expiration_date"|translate}}</label>
                <input type="Date" [placeholder]="'inventory.expiration_date'|translate" formControlName="expiry_date" class="input">
              </div>
            </div>
     
            <div class="insede_seperator"></div>
            <div class="step_title">
              <span>{{"inventory.inventory_levels"|translate}}</span>
            </div>
          <div class="content">
          <div class="inline_block">
            <div class="field">
              <label for="quantity">{{ "inventory.current_inventory" | translate }}</label>
              <input id="quantity" type="number" formControlName="quantity" min ="0" (keypress)="preventMinus($event)"
                [placeholder]="'inventory.current_inventory' | translate" />
              <span class="error_ms" *ngIf="form.get('quantity')?.errors?.['max']">
                {{ 'validation.max_quantity' | translate }}
              </span>
            </div>

            <div class="field">
              <label for="reorder_point">{{ "inventory.re-order_point" | translate }}</label>
              <input id="reorder_point" type="number" formControlName="reorder_point" min="0" (keypress)="preventMinus($event)"
                [placeholder]="'inventory.re-order_point' | translate" />
              <span class="error_ms" *ngIf="form.get('reorder_point')?.errors?.['max']">
                {{ 'validation.max_quantity' | translate }}
              </span>
            </div>
          </div>
          <div class="inline_block">
            <div class="field" [formGroup]="generalRulesform">
              <label for="reorder_point">{{"Catalogs.order_quantity_rules"|translate}}</label>
              <div class="inline_block">
                <div class="field">
                  <input type="number" formControlName="min_qte" (input)="sanitize($event)">
                  <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                  <span class="error_ms" *ngIf="generalRulesform.get('min_qte')?.touched  && generalRulesform.get('min_qte')?.hasError('required')">
                    {{"common.required_field" | translate}}
                  </span>
                  <span class="error_ms"  *ngIf="generalRulesform.hasError('minQte')">{{ generalRulesform.getError('minQte') }}</span>
                </div>
                <div class="field">
                  <input type="number" formControlName="increment" (input)="sanitize($event)">
                  <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                  <span class="error_ms" *ngIf="generalRulesform.get('increment')?.touched && generalRulesform.get('increment')?.hasError('required')">
                    {{"common.required_field" | translate}}
                  </span>
                  <span class="error_ms"  *ngIf="generalRulesform.hasError('increment')">{{ generalRulesform.getError('increment') }}</span>
                  <span class="error_ms"  *ngIf="generalRulesform.hasError('incrementMin')">{{ generalRulesform.getError('incrementMin') }}</span>
                </div>
                <div class="field">
                  <input type="number" formControlName="max_qte" (input)="sanitize($event)">
                  <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                  <span class="error_ms" *ngIf="generalRulesform.get('max_qte')?.touched  && generalRulesform.get('max_qte')?.hasError('required')">
                    {{"common.required_field" | translate}}
                  </span>
                  <span class="error_ms" *ngIf="generalRulesform.hasError('minMax')">{{ generalRulesform.getError('minMax') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
      <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
          <span>{{"common.back"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
      <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="save()">
            <span>{{"common.save"|translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
</div>
